import React from "react";
import {ArenaBaseModel} from "../arena-base.model";
import {
    ArenaConfiguration, ArenaGamesGridConfiguration,
    SwiperGamesListConfiguration
} from "../../../../configurations/config-data-sections/arenas.configuration";
import {CasinoArenaComponent} from "../../../../../components/arena-host/casino-arena/casino-arena.component";
import {GameInfo} from "../../../../games/game-info";
import {
    CASINO_GAMES_ARENA_NAME,
    EXCLUSIVE_ARENA_NAME,
    JACKPOTS_ARENA_NAME,
    SLOTS_ARENA_NAME
} from "../../../arena-consts";
import { computed, makeObservable } from "mobx";
import {ArenaFiltersConfigurationMap} from "../arena-view-model.interface";
import {filtersConfigurationToMap} from "../../filters-configuration-to-map";
import {IGamesFilterStrategy} from "../../../../games-filter/strategies/games-filter-strategy.interface";
import {
    AdvancedGamesFilterStrategy
} from "../../../../games-filter/strategies/advanced-filter/advanced-games-filter.strategy";
import {
    SimpleGamesFilterStrategy
} from "../../../../games-filter/strategies/simple-games-filter/simple-games-filter.strategy";
import {IServiceFactoryExtended} from "../../../../service-factory-extended.interface";
import {ListsSortOrderStorage} from "../../lists-sort-order-storage";

export class CasinoLobbyArenaModel extends ArenaBaseModel {
    constructor(arenaName: string,
                services: IServiceFactoryExtended,
                postLoginListsSortOrderStorage: ListsSortOrderStorage) {
        super(arenaName, services, postLoginListsSortOrderStorage);

        makeObservable(this);
    }

    get maxSwipersToShow(): number {
        return 20;
    }

    get maxGamesToShowInList(): number {
        return 30;
    }

    private get config(): ArenaConfiguration {
        return this.services.configuration.data.arenas[this.arenaName]
    }

    protected _getSwipersConfigurations(): SwiperGamesListConfiguration[] {
        return this.config.swiperGamesList || [];
    }

    protected _getGridsConfigurations(): ArenaGamesGridConfiguration[] {
        return this.config.allGamesGrid || [];
    }

    renderArena(): React.ReactElement | null {
        return <CasinoArenaComponent key={this.arenaName} arenaName={this.arenaName}/>;
    }

    protected _getPromotionalBannerConfig() {
        const bannerConfig = this.config.promotionalBanner;
        if(!bannerConfig) {
            return null;
        }

        if(this.services.device.hybrid.isEmbedded) {
            return null;
        }

        return {
            position: bannerConfig.displayListPlace || 2,
            templateID: bannerConfig.templateID,
            componentID: bannerConfig.componentID,
            fallbackComponent: bannerConfig.fallbackComponent,
            bannerAdminPlaceholderId: bannerConfig.bannerAdminPlaceholderId
        }
    }

    filterGamesByArenaType(gamesInfo: GameInfo[]): GameInfo[] {
        switch (this.arenaName) {
            case SLOTS_ARENA_NAME:
            case JACKPOTS_ARENA_NAME:
                return gamesInfo.filter(g => g.isVideoSlot);
            case EXCLUSIVE_ARENA_NAME:
                return gamesInfo.filter(g => g.isVideoSlot || g.isCasinoGame);
            case CASINO_GAMES_ARENA_NAME:
                return gamesInfo.filter(g => g.isCasinoGame);

            default:
                return gamesInfo.filter(g => !g.isLiveCasino);
        }
    }
    @computed
    get filtersConfigurationMap(): ArenaFiltersConfigurationMap {
        return filtersConfigurationToMap(this.config.filters);
    }

    getGamesFilteringStrategy(): IGamesFilterStrategy {
        if (this.useAdvancedFilters) {
            return new AdvancedGamesFilterStrategy(this.services);
        }
        return new SimpleGamesFilterStrategy(this.services);
    }
}
